module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "avatar m-auto"
  }, [(!_vm.imageToShow) ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "alt": "Click to add a picture"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.uploadPhoto($event)
      }
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#8ca0b3"
    },
    attrs: {
      "d": "M8 256C8 119.033 119.033 8 256 8s248 111.033 248 248-111.033 248-248 248S8 392.967 8 256zm72.455 125.868C119.657 436.446 183.673 472 256 472s136.343-35.554 175.545-90.132c-3.141-26.99-22.667-49.648-49.538-56.366l-32.374-8.093C323.565 339.79 290.722 352 256 352s-67.565-12.21-93.634-34.591l-32.374 8.093c-26.87 6.718-46.396 29.376-49.537 56.366zM144 208c0 61.856 50.144 112 112 112s112-50.144 112-112S317.856 96 256 96s-112 50.144-112 112z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.imageToShow) ? _c('div', {
    staticClass: "avatarHolder radius-circle",
    style: ({
      'background-image': 'url(' + _vm.imageToShow + ')'
    })
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(false) ? _c('ul', {
    staticClass: "fs-smallest text-center darker mb-4"
  }, [_c('li', [_vm._v("Minimum dimensions: 300x300px")]), _vm._v(" "), _c('li', {
    class: {
      'color-6': !_vm.isSizeOk
    }
  }, [_vm._v("Max. file size: 1MB")]), _vm._v(" "), _c('li', {
    class: {
      'color-6': !_vm.isFormatOk
    }
  }, [_vm._v("JPG or PNG only")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn secondary wide mt-3",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.uploadPhoto($event)
      }
    }
  }, [_vm._v("Select Picture")]), _vm._v(" "), _c('input', {
    ref: "inputAvatarUpload",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.receiveImage
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-851688aa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-851688aa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/AvatarUploader.vue
// module id = 1353
// module chunks = 0